import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';

export default function useJobHelpers() {
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();
    const getJobTypes = async () => {
        const response = await authenticatedApi.get(`/${orgId}/jobs/types`);
        return response.data;
    };

    const getJobClients = async (jobId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/jobs/${jobId}/account/assignments`,
        );
        return response.data;
    };

    const getJobAssignments = async (jobId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/jobs/${jobId}/assignments`,
        );

        return response.data;
    };

    const getJobs = async () => {
        const response = await authenticatedApi.get(`/${orgId}/jobs`);
        return response.data;
    };

    const getJob = async (jobId: number) => {
        const response = await authenticatedApi.get(`/${orgId}/jobs/${jobId}`);
        return response.data;
    };

    const getJobActivations = async (jobId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/activations/job/${jobId}`,
        );
        return response.data;
    };

    const getOrgActivations = async () => {
        const response = await authenticatedApi.get(`/${orgId}/activations`);
        return response.data;
    };

    const attachActivation = async (activationId: number, jobId: number) => {
        const response = await authenticatedApi.put(
            `/${orgId}/activations/${activationId}/job`,
            JSON.stringify({ jobId }),
        );
        return response.data;
    };

    const detachActivation = async (activationId: number) => {
        const response = await authenticatedApi.put(
            `/${orgId}/activations/${activationId}/job`,
            JSON.stringify({ jobId: null }),
        );
        return response.data;
    };

    const getJobGallery = async (jobId: number) => {
        const response = await authenticatedApi.get(
            `/${orgId}/jobs/${jobId}/gallery`,
            // Treat 404 (no gallery yet) as a normal, non-throwing response.
            { validateStatus: (status: number) => status < 500 },
        );
        return response.status === 200 ? response.data : null;
    };

    const createJobGallery = async (jobId: number, name?: string) => {
        const response = await authenticatedApi.post(
            `/${orgId}/jobs/${jobId}/gallery`,
            JSON.stringify(name ? { name } : {}),
        );
        return response.data;
    };

    return {
        getJobTypes,
        getJobClients,
        getJobAssignments,
        getJobs,
        getJob,
        getJobActivations,
        getOrgActivations,
        attachActivation,
        detachActivation,
        getJobGallery,
        createJobGallery,
    };
}
